import { Platform } from '__generated__/globalTypes';

import { useIsMobileApp } from './useIsMobileApp';

export const usePlatform = () => {
  const { isAndroidApp, isIosApp } = useIsMobileApp();
  if (isAndroidApp) return Platform.ANDROID;
  if (isIosApp) return Platform.IOS;
  return Platform.WEB;
};
